import GuaranteeShield from "@/assets/img/checkout/money-back-shield.svg"

/** "100% money back guarantee" trust pill. */
export function MoneyBackGuarantee() {
  return (
    <div className="mx-auto flex w-fit items-center gap-1.5 rounded-[20px] bg-purple-light/10 px-5 py-2.5">
      <img src={GuaranteeShield} alt="" className="size-[18px]" />
      <span className="text-sm font-semibold text-white">100% money back guarantee</span>
    </div>
  )
}
